/* eslint-disable  */
import { IconButton } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { PhotoCamera } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import "../../../css/Pages/Pages.css";
import { authActionCreators } from "../../../service/action-creators";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../service/action-creators/userDataAction";
import Loader from "../../Loader";
import RenderHome from "../home/RenderHome";
import "./UserProfile.css";
import Resizer from "react-image-file-resizer";

const Input = styled("input")({ display: "none" });

function UserProfile() {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    UpdateProfile,
    UpdateProfileImage,
    UpdateCoverImage,
    ResetResponse,
    GetUserProfile,
  } = bindActionCreators(authActionCreators, dispatch);

  const auth = useSelector((state) => state?.auth);
  const user = auth?.user;
  const isLoading = useSelector((state) => state?.auth?.isLoading);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    description: "",
    phone_number: "",
  });
  const [coverImagePreview, setCoverImagePreview] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [profileUrl, setProfileUrl] = useState("");
  const timestamp = new Date().getTime();

  const buildImageUrl = (url) => {
    if (!url) return url;
    if (url.includes("X-Amz-Signature")) return url;
    return `${url}?${timestamp}`;
  };

  const handlechange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCoverImageChange = (e) => {
    if (!e?.target.files[0]) return;
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (ev) => {
      setCoverImagePreview(ev?.target?.result);
      try {
        Resizer.imageFileResizer(
          file, 1200, 400, "png", 90, 0,
          (uri) => UpdateCoverImage(uri, user?.cover_image_key ?? ""),
          "file", 600, 200
        );
      } catch (err) {
        console.log(err);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleProfileImageChange = (e) => {
    if (!e?.target.files[0]) return;
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (ev) => {
      setProfileImagePreview(ev?.target?.result);
      try {
        Resizer.imageFileResizer(
          file, 400, 400, "png", 90, 0,
          (uri) => UpdateProfileImage(uri, user?.profile_image_key ?? ""),
          "file", 200, 200
        );
      } catch (err) {
        console.log(err);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const userImages = {
      profileImage: profileImagePreview,
      coverImage: coverImagePreview,
    };
    // UpdateProfile(formData, userImages);
  };

  useEffect(() => {
    GetUserProfile();
    dispatch(GetNotifications());
    dispatch(GetCartProducts());
  }, []);

  useEffect(() => {
    if (user) setFormData(user);
  }, [user?._id]);

  useEffect(() => {
    setProfileUrl(buildImageUrl(user?.profile_image));
  }, [user?.profile_image]);

  const refresh = () => window.location.reload(true);

  useEffect(() => {
    if (auth?.response?.state === "SUCCESS") {
      setTimeout(() => { GetUserProfile(); ResetResponse(); refresh(); }, 1500);
    } else if (auth?.response?.state === "FILE_UPLOADED") {
      GetUserProfile();
      ResetResponse();
    } else if (auth?.response?.state === "ERROR") {
      toast.error(auth?.response?.message);
      setTimeout(() => ResetResponse(), 1500);
    }
  }, [auth?.response?.state]);

  const coverBg = coverImagePreview || user?.cover_image;
  const avatarBg = profileImagePreview || buildImageUrl(user?.profile_image);

  return (
    <div className="ProfilePage">
      <RenderHome >
        {isLoading && <Loader />}

        {/* ── Cover Photo ── */}
        <div
          className="up-cover-photo"
          style={coverBg ? { backgroundImage: `url(${coverBg})` } : {}}
        >
          <label className="up-cover-upload-btn" htmlFor="cover-upload">
            <Input
              accept="image/*"
              id="cover-upload"
              type="file"
              onChange={handleCoverImageChange}
            />
            <IconButton component="span" size="small" style={{ padding: 2 }}>
              <PhotoCamera style={{ color: "#fff", fontSize: "1rem" }} />
            </IconButton>
            Change Cover
          </label>
        </div>

        {/* ── Profile Row ── */}
        <div className="up-profile-row">
          {/* Avatar */}
          <div
            className="up-avatar-wrap"
            style={avatarBg ? { backgroundImage: `url(${avatarBg})` } : {}}
          >
            <img src={avatarBg} alt={user?.name || ""} />
            <label className="up-avatar-upload" htmlFor="avatar-upload">
              <Input
                accept="image/*"
                id="avatar-upload"
                type="file"
                onChange={handleProfileImageChange}
              />
              <IconButton component="span" size="small" style={{ padding: 2 }}>
                <PhotoCamera style={{ color: "#fff", fontSize: "1rem" }} />
              </IconButton>
            </label>
          </div>

          {/* Name / ID / Badge */}
          <div className="up-user-info">
            <h2>{user?.name || "—"}</h2>
            <p>Staff ID: {user?.staff_id || "—"}</p>
            {user?.user_type && (
              <span className="up-badge">{user.user_type}</span>
            )}
          </div>

          {/* Action buttons */}
          <div className="up-actions">
            <button className="up-btn-cancel" onClick={() => history.push("/home")}>
              Cancel
            </button>
            <button className="up-btn-save" onClick={handleSubmit}>
              Save Details
            </button>
          </div>
        </div>

        {/* ── Cards ── */}
        <div className="up-cards">

          {/* Personal Information */}
          <div className="up-card">
            <div className="up-card-header">
              <div className="up-card-header-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
              <div>
                <h3>Personal Information</h3>
                <p>Update your contact and personal details</p>
              </div>
            </div>
            <div className="up-card-body">
              <div className="up-form-row">
                <div className="up-form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    readOnly
                    defaultValue={user?.email}
                    className="form-control"
                    placeholder="Not set"
                  />
                </div>
                <div className="up-form-group">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    defaultValue={user?.dob}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>
              <div className="up-form-row">
                <div className="up-form-group">
                  <label>Contact Number</label>
                  <input
                    type="tel"
                    name="phone_number"
                    className="form-control"
                    defaultValue={user?.phone_number}
                    placeholder="Not set"
                    onChange={handlechange}
                  />
                </div>
                <div className="up-form-group">
                  <label>Username</label>
                  <input
                    type="text"
                    name="username"
                    defaultValue={user?.name?.split(" ")[1]}
                    readOnly
                    className="form-control"
                    placeholder="Not set"
                  />
                </div>
              </div>
              <div className="up-form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  defaultValue={user?.description}
                  onChange={handlechange}
                  rows={3}
                  placeholder="Write a brief info about yourself…"
                />
              </div>
            </div>
          </div>

          {/* Work Information */}
          <div className="up-card">
            <div className="up-card-header">
              <div className="up-card-header-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                  <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                </svg>
              </div>
              <div>
                <h3>Work Information</h3>
                <p>These fields are managed by the system</p>
              </div>
            </div>
            <div className="up-card-body">
              <div className="up-readonly-note">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                  <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                These details are read-only and can only be updated by an administrator.
              </div>
              <div className="up-form-row">
                <div className="up-form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    defaultValue={user?.name}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="up-form-group">
                  <label>Staff ID</label>
                  <input
                    type="text"
                    defaultValue={user?.staff_id}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>
              <div className="up-form-row">
                <div className="up-form-group">
                  <label>Facility</label>
                  <input
                    type="text"
                    defaultValue={user?.facility}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="up-form-group">
                  <label>Department</label>
                  <input
                    type="text"
                    defaultValue={user?.department}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>
              <div className="up-form-row">
                <div className="up-form-group">
                  <label>Region</label>
                  <input
                    type="text"
                    defaultValue={user?.region}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="up-form-group">
                  <label>District</label>
                  <input
                    type="text"
                    defaultValue={user?.district}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>

        <ToastContainer autoClose={3000} />
      </RenderHome>
    </div>
  );
}

export default UserProfile;
